export class ArrayQueue<T> {
  private array: T[] = [];

  constructor(private readonly maxSize: number) {}

  length(): number {
    return this.array.length;
  }

  push(item: T): void {
    if (this.array.length >= this.maxSize) {
      this.array.shift();
    }
    this.array.push(item);
  }

  shift(): T | undefined {
    return this.array.shift();
  }

  reset(): void {
    this.array = [];
  }
}
